import { useFilterEmploymentStatusContext } from "./filter-employment-status.context";

export function FilterEmploymentStatus() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmploymentStatusContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}